<template>
  <VDropdown
    placement="bottom-end"
    @apply-show="isFocusLoopActive = true"
    @apply-hide="isFocusLoopActive = false"
  >
    <button
      class="tw-inline-flex tw-h-full tw-items-center tw-p-1"
      test_id="navbar"
    >
      <Avatar
        :src="currentUser.avatarUrl"
        :alt="`${currentUser.firstName} ${currentUser.lastName}`"
        disable-lazy-loading
      />
      <ArrowDownIcon class="tw-ml-2 tw-w-3" />
    </button>
    <template #popper>
      <div
        class="tw-max-w-[300px] tw-overflow-x-hidden tw-overflow-y-hidden tw-rounded-lg tw-shadow-md"
      >
        <FocusLoop
          :is-active="isFocusLoopActive"
          :auto-focus="false"
          is-arrows-navigation-active
        >
          <div class="tw-p-2">
            <InertiaLink
              :href="currentUser.profileUrl"
              class="tw-flex tw-items-center tw-justify-between tw-space-x-6 tw-rounded-lg tw-p-3 hover:tw-bg-neutral-50"
            >
              <div class="tw-flex tw-items-center tw-space-x-3">
                <Avatar
                  :src="currentUser.avatarUrl"
                  :alt="`${currentUser.firstName} ${currentUser.lastName}`"
                  disable-lazy-loading
                  size="lg"
                  class="tw-flex-shrink-0"
                />
                <div class="tw-flex tw-flex-col">
                  <span class="tw-font-semibold">
                    {{ currentUser.firstName }} {{ currentUser.lastName }}
                  </span>
                  <span class="tw-text-xs tw-text-neutral-400">
                    view profile
                  </span>
                </div>
              </div>
              <BaseIcon
                name="arrow-sm-right"
                color="neutral-400"
                class="tw-size-4"
              />
            </InertiaLink>
            <ul class="tw-flex tw-flex-col">
              <li
                v-for="(item, index) in navigation[accessControl.role]"
                :key="index"
                class="tw-w-full"
              >
                <component
                  :is="item.as"
                  v-bind="{ ...item.attrs, ...item.actions }"
                  :href="item.isDisabled ? 'javascript:void(0)' : item.href"
                  class="tw-block tw-w-full tw-rounded-lg tw-px-4 tw-py-2 tw-text-left tw-text-sm tw-text-neutral-700 tw-transition-colors hover:tw-bg-neutral-50 hover:tw-text-current focus:tw-bg-neutral-100 focus:tw-outline-none"
                  :class="{
                    'tw-cursor-not-allowed': item.isDisabled,
                  }"
                >
                  <div class="tw-inline-flex tw-items-center">
                    <component
                      :is="item.icon"
                      class="tw-mr-3 tw-h-4 tw-w-4"
                      :class="item.iconClasses"
                    />
                    <span>{{ item.name }}</span>
                    <span
                      v-if="item.isNew"
                      class="tw-ml-2 tw-rounded-md tw-bg-success-100 tw-px-1 tw-py-0.5 tw-text-xs tw-text-success-600"
                    >
                      New
                    </span>
                  </div>
                  <span
                    v-if="item.description"
                    class="tw-mt-1 tw-flex tw-text-xs"
                    :class="{ 'tw-text-neutral-400': item.isDisabled }"
                  >
                    {{ item.description }}
                  </span>
                </component>
                <hr v-if="item.hasBottomSeparator" class="tw-my-1" />
              </li>
            </ul>
          </div>
        </FocusLoop>
      </div>
    </template>
  </VDropdown>
</template>

<script setup>
import Avatar from '../avatar/Avatar.vue'
import FocusLoop from '../FocusLoop.vue'
import ArrowDownIcon from '@/assets/images/icons/arrow-down.svg'
import { useCurrentUser } from '@/shared/composables/useCurrentUser'
import { ref } from 'vue'
import { usePermissionSystem } from '@/shared/composables/usePermissionSystem.js'
import BaseIcon from '@/shared/components/BaseIcon.vue'

defineProps({
  navigation: {
    type: Object,
    required: true,
  },
})

const { accessControl } = usePermissionSystem()
const { currentUser } = useCurrentUser()

const isFocusLoopActive = ref(false)
</script>
